export default __webpack_public_path__ + "static/media/polyester.31dda2eb.jpg";